import React from 'react';
import { Button } from '@/components/ui/button';
import { KeenIcon } from '@/components/keenicons';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';

const AgentUpgradeBox = () => (
  <div className="flex flex-col items-center gap-3">
    <div className='flex flex-row justify-center items-center gap-2'>
      <FontAwesomeIcon icon={faLock} className='size-7 text-yellow-400'/>
      <div className="text-3xl font-bold text-red-600 text-center">
        <FormattedMessage id="AGENTS.HOME.ACCOUNT_NOT_ALLOWED" />
      </div>
    </div>
    <div className="text-gray-600 text-center text-sm pb-5">
      <FormattedMessage id="AGENTS.HOME.UPGRADE_REQUIRED" />
    </div>
    <Button className="bg-[#50CD54] w-40 h-10 flex items-center gap-3">
      <FormattedMessage id="AGENTS.HOME.UPGRADE"/>
      <img src="/media/images/icon/upgrade_white.png" alt="" width={15}/>
    </Button>
  </div>
);

export { AgentUpgradeBox }; 